module.exports = __webpack_public_path__ + "img/10.b998c3a7.jpg";